//
// Necessary bit of evil to get strict typing on the actions without having verbose action creators.
//
export const makeActionFactory = <T extends string>() => ({
    empty: <A extends { type: T }>(type: T) =>
        () =>
            ({ type }) as A,

    payload: <A extends { type: T; payload: P }, P>(type: T) =>
        (payload: P) =>
            ({ type, payload }) as A,

    payloadMeta: <A extends { type: T; payload: P; meta: M }, P, M>(type: T) =>
        (payload: P, meta: M) =>
            ({ type, payload, meta }) as A,

    meta: <A extends { type: T; meta: M }, M>(type: T) =>
        (meta: M) =>
            ({ type, meta }) as A,

    error: <A extends { type: T; payload: Error; error: boolean }>(type: T) =>
        (err: Error) =>
            ({ type, payload: err, error: true }) as A,

    errorMeta: <A extends { type: T; payload: Error; error: boolean; meta: M }, M>(type: T) =>
        (err: Error, meta: M) =>
            ({ type, payload: err, error: true, meta }) as A,
});



// WEBPACK FOOTER //
// ./src/actions/actionFactory.ts